export const TAB_VARIANTS = {
    lift: 'lift',
    sub: 'sub',
    underline: 'underline',
    header: 'header',
} as const;

export type TabVariant = (typeof TAB_VARIANTS)[keyof typeof TAB_VARIANTS];

export interface VariantClasses {
    tablist: string;
    tab: string;
    activeTab: string;
    inactiveTab: string;
}

const UNDERLINE_TAB =
    'border-b-2 px-0.5 py-3 text-sm font-medium transition-colors motion-reduce:transition-none focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-mp-link';

const UNDERLINE_CLASSES: VariantClasses = {
    tablist: 'flex flex-wrap gap-7 border-b border-mp-border',
    tab: `-mb-px ${UNDERLINE_TAB}`,
    activeTab: 'border-mp-primary text-mp-link',
    inactiveTab: 'border-transparent text-mp-muted hover:text-mp-foreground',
};

export const VARIANT_CLASSES: Record<TabVariant, VariantClasses> = {
    [TAB_VARIANTS.lift]: {
        tablist: 'flex flex-wrap border-b border-mp-border',
        tab: '-mb-px inline-flex h-10 items-center justify-center rounded-t-lg border px-4 text-sm transition-colors motion-reduce:transition-none focus-visible:outline-2 focus-visible:-outline-offset-4 focus-visible:outline-mp-link',
        activeTab: 'border-x-mp-border border-t-mp-border border-b-mp-surface bg-mp-surface text-mp-foreground',
        inactiveTab: 'border-transparent text-mp-muted hover:text-mp-foreground',
    },
    [TAB_VARIANTS.sub]: {
        tablist: 'mb-4 inline-flex w-fit rounded-lg bg-mp-border p-0.5',
        tab: 'rounded-md px-4 py-2 text-sm font-medium transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-mp-primary',
        activeTab: 'bg-mp-surface text-mp-foreground shadow',
        inactiveTab: 'text-mp-foreground/70',
    },
    [TAB_VARIANTS.underline]: UNDERLINE_CLASSES,
    // DetailPageHeader's tabs: one row that scrolls. The tablist, not each tab, overlaps the band's
    // bottom border, so the scroll box does not clip the underline.
    [TAB_VARIANTS.header]: {
        ...UNDERLINE_CLASSES,
        tablist: '-mb-px flex gap-7 overflow-x-auto',
        tab: `shrink-0 whitespace-nowrap ${UNDERLINE_TAB}`,
    },
};
